import { axios } from '@/utils/request'
const api = "/index"
export default {
AddProblem: (parameter) => {
    return axios({
        url: `${api}/AddProblem `,
        method: 'post',
        data: parameter
    })
},
SaveProblem: (parameter) => {
    return axios({
        url: `${api}/SaveProblem `,
        method: 'post',
        data: parameter
    })
},
problemList: (parameter) => {
    return axios({
        url: `${api}/problemList `,
        method: 'post',
        data: parameter
    })
},
deleteProblem: (parameter) => {
    return axios({
        url: `${api}/deleteProblem `,
        method: 'post',
        data: parameter
    })
},
AddCategory: (parameter) => {
    return axios({
        url: `${api}/AddCategory `,
        method: 'post',
        data: parameter
    })
},
categoryList: (parameter) => {
    return axios({
        url: `${api}/categoryList `,
        method: 'post',
        data: parameter
    })
},
FindCategory: (parameter) => {
    return axios({
        url: `${api}/FindCategory `,
        method: 'post',
        data: parameter
    })
},
AddCategory: (parameter) => {
    return axios({
        url: `${api}/AddCategory `,
        method: 'post',
        data: parameter
    })
},
SaveCategory: (parameter) => {
    return axios({
        url: `${api}/SaveCategory `,
        method: 'post',
        data: parameter
    })
},
deleteCategory: (parameter) => {
    return axios({
        url: `${api}/deleteCategory `,
        method: 'post',
        data: parameter
    })
},

}
